"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GqlClient = void 0;
var tslib_1 = require("tslib");
var logger_1 = require("@hit/logger");
var graphql_request_1 = require("graphql-request");
var Ctx_1 = require("./Ctx");
var Utils_1 = require("./Utils");
var GqlClient = /** @class */ (function () {
    function GqlClient() {
        this.retries = 3;
        this.retryTimeout = 100;
    }
    GqlClient.new = function (options) {
        return new this().init(options);
    };
    Object.defineProperty(GqlClient.prototype, "log", {
        get: function () {
            return Ctx_1.Ctx.get.logger(this.constructor.name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GqlClient.prototype, "logRequest", {
        get: function () {
            return Ctx_1.Ctx.get.logger(this.constructor.name, 'req', { category: logger_1.Category.request });
        },
        enumerable: false,
        configurable: true
    });
    GqlClient.prototype.init = function (options) {
        this.retries = options.retries || 3;
        this.retryTimeout = options.retryTimeout || 100;
        this.url = "".concat(options.url, "/gql");
        this.client = new graphql_request_1.GraphQLClient(this.url, {
            headers: {
                Authorization: "Bearer ".concat(options.authToken || Ctx_1.Ctx.get.config.AUTH_TOKEN)
            }
        });
        this.log.info('init', 'Initializing', {
            URL: this.url,
            retries: this.retries,
            retryTimeout: this.retryTimeout
        });
        return this;
    };
    GqlClient.prototype.buildQuery = function (obj) {
        if (obj instanceof Array && obj.length > 0) {
            obj = obj[0];
        }
        var keys = Object.keys(obj);
        if (keys.length === 0) {
            return '';
        }
        var query = '{';
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            query = "".concat(query, " ").concat(key);
            if (obj[key] !== null && typeof obj[key] === 'object' && !(obj[key] instanceof Date)) {
                query = "".concat(query, " ").concat(this.buildQuery(obj[key]));
            }
        }
        return "".concat(query, " }");
    };
    GqlClient.prototype.query = function (query, variables) {
        return this.interact(query, variables);
    };
    GqlClient.prototype.interact = function (query, variables, retryAttempt) {
        var _a, _b;
        if (retryAttempt === void 0) { retryAttempt = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var logCtx, response, err_1;
            var _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 5]);
                        logCtx = (_b = (_a = this.log.havenLogger).getContextFromLocalStorage) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [4 /*yield*/, this.client.request(query, variables, (_c = {},
                                _c["HT-Global-Id" /* GlobalHeader.HT_GLOBAL_ID */.toLowerCase()] = (logCtx === null || logCtx === void 0 ? void 0 : logCtx.globalId) || '--',
                                _c["HT-Global-Source" /* GlobalHeader.HT_GLOBAL_SOURCE */.toLowerCase()] = (logCtx === null || logCtx === void 0 ? void 0 : logCtx.globalSource) || '--',
                                _c))];
                    case 1:
                        response = _d.sent();
                        this.checkErrors(response, query, variables);
                        return [2 /*return*/, {
                                data: response
                            }];
                    case 2:
                        err_1 = _d.sent();
                        if (!(err_1.code === 'ECONNRESET' && retryAttempt < this.retries)) return [3 /*break*/, 4];
                        retryAttempt++;
                        this.log.warn('errorHandler', 'GQL ECONNRESET, retrying ...', {
                            url: this.url,
                            retryAttempt: retryAttempt,
                            retryTimeout: this.retryTimeout
                        });
                        return [4 /*yield*/, Utils_1.Utils.delay(this.retryTimeout * retryAttempt)];
                    case 3:
                        _d.sent();
                        return [2 /*return*/, this.interact(query, variables, retryAttempt)];
                    case 4:
                        this.checkErrors(err_1.response, query, variables);
                        this.logRequest.error('errorHandler', 'GQL error', err_1, { url: this.url, query: query, variables: variables });
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    GqlClient.prototype.checkErrors = function (response, query, variables) {
        if (response.errors) {
            var errorMessages = response.errors.reduce(function (messages, error) {
                var message = error.message;
                messages += "".concat(message, "\n");
                return messages;
            }, '');
            var e = new Error("GQL error was found:\n ".concat(errorMessages.replace(/\\/gi, '')
                .replace(/"dob".*?,/gi, '"dob":"****-**-**"')));
            this.logRequest.error('errorHandler', 'GQL error', e, { url: this.url, query: query, variables: variables });
            throw e;
        }
    };
    return GqlClient;
}());
exports.GqlClient = GqlClient;
//# sourceMappingURL=GqlClient.js.map